// extracted by mini-css-extract-plugin
export default {"container":"src-constrains-Query1-Filter-css-module__container--EMuXY","filterText":"src-constrains-Query1-Filter-css-module__filterText--Vhv6m"};